import axios from 'axios';

// Usa l'URL dell'env variable se disponibile, altrimenti fallback al proxy relativo
const API_BASE = import.meta.env.VITE_API_URL || '/api/v1';

console.log('[API] Base URL:', API_BASE);

// Helper per leggere cookie
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  withCredentials: true,  // Importante per inviare i cookie
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper functions for localStorage token
const TOKEN_KEY = 'm4b_access_token';
const CSRF_COOKIE_NAME = 'm4b_csrf';
const CSRF_HEADER_NAME = 'X-CSRF-Token';

export const getToken = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token) => {
  if (typeof window === 'undefined') return;
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const clearToken = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(TOKEN_KEY);
};

// Request interceptor - add Authorization header and CSRF token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Aggiungi CSRF token per richieste che modificano stato
    const methodsRequiringCsrf = ['post', 'put', 'delete', 'patch'];
    if (methodsRequiringCsrf.includes(config.method?.toLowerCase())) {
      const csrfToken = getCookie(CSRF_COOKIE_NAME);
      if (csrfToken) {
        config.headers[CSRF_HEADER_NAME] = csrfToken;
        console.log('[CSRF] Token added to request:', config.url);
      } else {
        console.warn('[CSRF] No CSRF token found in cookies for:', config.url);
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      
      const url = String(error.config?.url || '');
      const isAuthBootstrap = url.includes('/auth/me');
      const isAuthFlow = url.includes('/auth/login') || url.includes('/auth/register');
      const alreadyOnLogin = typeof window !== 'undefined' && window.location?.pathname === '/login';

      if (!isAuthBootstrap && !isAuthFlow && !alreadyOnLogin) {
        window.location.href = '/login';
      }
    }
    
    // Log CSRF errors
    if (error.response?.status === 403 && error.response?.data?.detail?.includes('CSRF')) {
      console.error('[CSRF] CSRF validation failed:', error.response.data);
    }
    
    return Promise.reject(error);
  }
);
